var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"loader_container"}},[_c('div',[_c('Loader'),(_vm.loaderTitle)?_c('h1',[_vm._v(" "+_vm._s(_vm.loaderTitle)+" ")]):_vm._e(),(_vm.loaderText)?_c('span',{staticClass:"pre-text"},[_vm._v(" "+_vm._s(_vm.loaderText)+" ")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }